import { Action } from 'redux'
import { put, takeLatest, all } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload, IListSearchQueryPaginationPayload } from '@app-store/slices/rfqs/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}
interface TaskSearchAction extends Action {
    payload: IListSearchQueryPaginationPayload
}

const {
    onRequest,
    onFilteredDataRequest,
    onSuccess,
    onFailure,
    onRequestSearch,
    onFailureSearch,
    onListData,
    onFilteredData,
    onSuccessSearch
} = rootActions.rfqs.list

function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            query: payload.query,
            'populates[]': [
                { path: 'products.product' },
                { path: 'company', select: 'name _id logo' },
                { path: 'createdByContact', select: 'firstname lastname _id avatar jobTitle' }
            ],
            needPopulate: true
        }

        const response = yield axios.get(`/companies/rfqs`, {
            params
        })
        if (response.success) {
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
            yield put(onSuccess({ ...response.result, keepOldData: payload.keepOldData || false }))
            yield put(onListData(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}
function* listFilterSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            query: payload.query,
            'populates[]': [
                { path: 'products.product' },
                { path: 'company', select: 'name _id logo' },
                { path: 'createdByContact', select: 'firstname lastname _id avatar jobTitle' }
            ],
            needPopulate: true
        }

        const response = yield axios.get(`/companies/rfqs`, {
            params
        })
        if (response.success) {
            yield put(onFilteredData(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}
function* searchSagaTask({ payload }: TaskSearchAction) {
    try {
        const params = {
            ...payload.pagination,
            textSearch: payload.textSearch
        }

        const response = yield axios.get(`/search/rfqs`, {
            params
        })
        if (response.success) {
            yield put(onSuccessSearch(response.result))
        }
    } catch (error) {
        yield put(onFailureSearch(error))
    }
}

function* listSaga(): any {
    yield all([
        takeLatest<TaskAction>(onRequest, listSagaTask),
        takeLatest<TaskAction>(onFilteredDataRequest, listFilterSagaTask),
        takeLatest<TaskSearchAction>(onRequestSearch, searchSagaTask)
    ])
}

export default listSaga
